import React, { useState } from "react";
import { Button, Input, Select, Slider, Switch } from "antd";
import { LCRadio, LCRadioGroup } from "../../../frameWork";
import styles from "./NavigationModalFields.module.scss";
import { svgOptions } from "../../../utils/svgOptions";
import getRighNavtSVG from "../../../utils/RightnavSvg";
import { ChromePicker } from "react-color";

const NAME_LIMIT = 25;
const TOOLTIP_LIMIT = 100;

export const NavModalFields = ({
	handleCancel,
	data,
	changeNavItems,
	uploadFile,
	onUploadNewNav,
}) => {
	const [showColorPicker, setShowColorPicker] = useState(false);
	const isCore = data.tabType && data.tabType.toUpperCase() === 'CORE' && data.name !== 'Chat';

	return (
		<div className={styles.wrapper}>
		<div className={styles.container}>

			{/* Name & Tooltip — side by side */}
			<div className={styles.sectionRow}>
				<div className={styles.section}>
					<label className={styles.label}>Name</label>
					<Input
						placeholder="Tab Name"
						value={data.name}
						onChange={(e) => changeNavItems("name", e.target.value)}
					/>
					<span className={styles.charCount}>{(data.name || '').length}/{NAME_LIMIT}</span>
				</div>
				<div className={styles.section}>
					<label className={styles.label}>Tooltip</label>
					<Input
						placeholder="Tooltip comment"
						value={data.tooltip}
						onChange={(e) => changeNavItems("tooltip", e.target.value)}
					/>
					<span className={styles.charCount}>{(data.tooltip || '').length}/{TOOLTIP_LIMIT}</span>
				</div>
			</div>

			{/* Placement */}
			<div className={styles.section}>
				<label className={styles.label}>Placement</label>
				<LCRadioGroup
					className={styles.radioGroup}
					value={data.position}
					onChange={(e) => changeNavItems("position", e.target.value)}>
					<LCRadio value="TOP">Top</LCRadio>
					<LCRadio value="MIDDLE">Middle</LCRadio>
					<LCRadio value="BOTTOM">Bottom</LCRadio>
					{!isCore && data.coreId !== 'LIA' && <LCRadio value="LEFT">Left</LCRadio>}
				</LCRadioGroup>
			</div>

			{/* Link */}
			{!isCore && data.coreId !== 'LIA' && (
				<div className={styles.section}>
					<label className={styles.label}>Link</label>
					<LCRadioGroup
						className={styles.radioGroup}
						value={data.type}
						onChange={(e) => changeNavItems("type", e.target.value)}>
						<LCRadio value="EXTERNAL">External</LCRadio>
						<LCRadio value="INTERNAL">Main Content</LCRadio>
						{data.position !== "LEFT" && (
							<LCRadio value="RIGHT_NAV">Right Nav</LCRadio>
						)}
					</LCRadioGroup>
					<Input
						placeholder="Link"
						value={data.link}
						onChange={(e) => changeNavItems("link", e.target.value.trim())}
					/>
				</div>
			)}

			{/* Icon */}
			<div className={`${styles.section} ${styles.imageGroup}`}>
				<label className={styles.label}>Icon</label>
				<LCRadioGroup
					className={styles.radioGroup}
					value={data.iconType}
					onChange={(e) => changeNavItems("iconType", e.target.value)}>
					<LCRadio value="SVG">SVG</LCRadio>
					<LCRadio value="IMAGE">Image</LCRadio>
					<LCRadio value="CUSTOM_SVG">Custom SVG</LCRadio>
				</LCRadioGroup>
				{data.iconType === "SVG" ? (
					<Select
						showSearch
						placeholder="Select"
						value={data.icon || undefined}
						onChange={(value) => changeNavItems("icon", value)}>
						{svgOptions.map((item) => (
							<Select.Option key={item.value} value={item.value || undefined}>
								<span className={styles.iconBlock}>
									{getRighNavtSVG(item.value)} {item.label}
								</span>
							</Select.Option>
						))}
					</Select>
				) : data.iconType === "CUSTOM_SVG" ? (
					<Input.TextArea
						rows={6}
						placeholder="Paste SVG code here e.g. <svg xmlns=...>...</svg>"
						value={data.icon || ""}
						onChange={(e) => changeNavItems("icon", e.target.value)}
						style={{ fontFamily: "monospace", fontSize: 12 }}
					/>
				) : (
					<div className={styles.imageUploadGroup}>
						{data.icon && (
							<img src={data.icon} alt="icon" className={styles.iconPreview} />
						)}
						<input
							className="nave-image"
							type="file"
							id="imgup1"
							name="imagefile"
							onChange={(event) => uploadFile(event.target.files[0])}
							accept=".png"
						/>
					</div>
				)}
			</div>

			{/* Visibility */}
			<div className={styles.toogleGroup}>
				<label className={styles.label}>Visibility</label>
				<Switch
					checked={data.visibility}
					onChange={(checked) => changeNavItems("visibility", checked)}
				/>
			</div>

			{/* Padding & Background — for RIGHT_NAV items and LIA core item */}
			{['TOP', 'MIDDLE', 'BOTTOM'].includes(data.position) && ((!isCore && data.type === 'RIGHT_NAV') || data.coreId === 'LIA' || data.coreId === 'AI_CHAT') && (
				<>
					<div className={styles.section}>
						<label className={styles.label}>Padding</label>
						<div className={styles.controlRow}>
							<Slider
								value={data.padding || 0}
								min={0}
								max={40}
								style={{ flex: 1 }}
								onChange={(value) => changeNavItems('padding', value)}
							/>
							<span className={styles.paddingValue}>{data.padding || 0}px</span>
						</div>
					</div>

					<div className={styles.section}>
						<label className={styles.label}>Background</label>
						<div className={styles.controlRow}>
							<Input
								value={data.background || '#06a7e1ff'}
								style={{ flex: 1 }}
								onChange={(e) => changeNavItems('background', e.target.value)}
							/>
							<span
								className={styles.colorSwatch}
								style={{ backgroundColor: data.background || '#06a7e1' }}
								onClick={() => setShowColorPicker(prev => !prev)}
							/>
							{showColorPicker && (
								<div className={styles.colorPickerPopover}>
									<div
										className={styles.colorPickerBackdrop}
										onClick={() => setShowColorPicker(false)}
									/>
									<ChromePicker
										color={data.background || '#06a7e1ff'}
										onChangeComplete={(color) => changeNavItems('background', color.hex)}
									/>
								</div>
							)}
						</div>
					</div>
				</>
			)}

		</div>
		{/* Actions — outside scroll area */}
		<div className={styles.actions}>
			<Button className="secondary-btn" onClick={handleCancel}>Cancel</Button>
			<Button className="primary-btn" onClick={onUploadNewNav}>Submit</Button>
		</div>
		</div>
	);
};
